import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';

import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class DesignerModalIntroTourComponent extends PopupInnerModalComponent<PopupData.None> {
	@service('flow/tour/designer') declare flowTourDesignerService: Service.Flow.Tour.Designer;
	@service('navigation') declare navigationService: Service.Navigation;

	videoUrl = 'https://player.vimeo.com/video/951418821?autoplay=1';

	@action
	skipTour(): void {
		this.flowTourDesignerService.endAllTours();
		this.close();
	}

	@action
	openVideoPopup() {
		this.navigationService.openVideoPopup(this.videoUrl);
	}
	<template>
		<div class="content">

			<div class="video-wrapper">
				<a role="button" {{on "click" this.openVideoPopup}}>
					<img
						src="https://cdn1.databox.com/analytics/home-screen/video-placeholder-card.png"
						width="522"
						height="297"
						alt
					/>
				</a>
			</div>

			<h2>Welcome to your Dashboard designer</h2>

			<p>
				<strong>In less than a minute,</strong>
				learn how you can easily create and customize beautiful dashboards. It's your space
				to visualize your most important data from all your favorite sources!
			</p>

			<div class="controls2 controls2--center">
				<SubmitButtonComponent
					@text="Let's do it!"
					@noDelay={{true}}
					@onTrigger={{this.close}}
				/>
				<SubmitButtonComponent
					@text="No thanks, I will explore on my own"
					@theme="grey-empty"
					@noDelay={{true}}
					@onTrigger={{this.skipTour}}
				/>
			</div>

		</div>
	</template>
}
